import {
  ShopLandingPageLayout,
  ShopLandingPageTextColor,
  ShopLandingPageImageOverlay,
} from '../CmsLandingPage.d'

export interface FeatureBlockProps {
  backgroundColor: 'Light' | 'Dark'
  backgroundImage?: string
  buttonText?: string
  buttonUrl?: string
  contentfulId: string
  contentType: string
  imageOverlay: ShopLandingPageImageOverlay
  imageWidth?: number
  layout: ShopLandingPageLayout
  slot?: number
  subText?: string
  textColor: ShopLandingPageTextColor
  title: string
}

export const FEATURE_SECTION_COMPONENT_TYPE = 'feature_banner'

export const SINGLE_BLOCK_SECTION_WIDTH = 2640
export const DOUBLE_BLOCK_SECTION_WIDTH = 1320
